/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  //backend_url_Pos:  "/v1/",
  backend_url_Pos:  "https://be.adcaisse.online/bp-api-pos/v1/",
  backend_url_Admin: "https://be.adcaisse.online/bp-api-admin/v1/",
  backend_url_Product: "https://be.adcaisse.online/bp-api-product/v1/",
  backend_url_Transaction: "https://be.adcaisse.online/bp-api-transaction/v1/",
  backend_url_Analytics: "https://be.adcaisse.online/bp-api-analytics/v1/",
  //backend_url_Analytics: "/v1/",
  backend_url_Reservation: "https://be.adcaisse.online/bp-api-reservation/v1/",
  backend_url_loyality: "https://be.adcaisse.online/bp-api-loyality-v2/v1/",
  backend_url_customer: "https://be.adcaisse.online/bp-api-customer/v1/",
  backend_url_Notification: "https://be.adcaisse.online/bp-api-notification/v1/",


  // backend_url_Pos:"http://51.178.47.149:8080/bp-api-pos/v1/",
  // backend_url_Admin:"http://51.178.47.149:8080/bp-api-admin/v1/",
  // backend_url_Product:"http://51.178.47.149:8080/bp-api-product/v1/",
  // backend_url_Transaction:"http://51.178.47.149:8080/bp-api-transaction/v1/",
  // backend_url_Analytics:"http://51.178.47.149:8080/bp-api-analytics/v1/",
  // backend_url_Reservation:"http://51.178.47.149:8080/bp-api-reservation/v1/",
  // backend_url_loyality:"http://51.178.47.149:8080/bp-api-loyality-v2/v1/",
  // backend_url_customer:"http://51.178.47.149:8080/bp-api-customer/v1/",
  // backend_url_Notification:"http://51.178.47.149:8080/bp-api-notification/v1/",
  // backend_url_local:"http://127.0.0.1:8080/v1/"


  image_url: 'https://images.adcaisse.online',

  // backend_url_Pos:"http://51.178.47.149:8080/bp-api-pos/v1/",
  // backend_url_Admin:"http://51.178.47.149:8080/bp-api-admin/v1/",
  // backend_url_Product:"http://51.178.47.149:8080/bp-api-product/v1/",
  // backend_url_Transaction:"http://51.178.47.149:8080/bp-api-transaction/v1/",
  // backend_url_Analytics:"http://51.178.47.149:8080/bp-api-analytics/v1/",
  // backend_url_Reservation:"http://51.178.47.149:8080/bp-api-reservation/v1/",
  // backend_url_loyality:"http://51.178.47.149:8080/bp-api-loyality-v2/v1/",
  // backend_url_customer:"http://51.178.47.149:8080/bp-api-customer/v1/",
  // backend_url_Notification:"http://51.178.47.149:8080/bp-api-notification/v1/",
  // backend_url_local: "http://localhost:8080/v1/",

  // image_url:'https://images.adcaisse.online',
};
